import styled from 'styled-components';
import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';

export type DisplayType = 'inline-block' | 'block';

interface WrapperProps {
  width?: number;
  displayType?: DisplayType;
  align?: 'left' | 'right';
}

export const DropdownWrapper = styled('div')<WrapperProps>`
  position: relative;
  display: ${({ displayType }) => (displayType && displayType) || `block`};
`;

export const Wrapper = styled('div')<WrapperProps>`
  && {
    position: absolute;
    z-index: 9999;
    background: ${({ theme }) => theme.color.white};
    border-radius: 4px 4px 0 0;
    width: 100%;
    min-width: ${({ width }) => width || 224}px;
    margin: ${({ theme }) => theme.x1spacePx}px 0 0;
    input {
      border: ${({ theme }) => `1px solid ${theme.color.whiteRGBA(0.2)}`};
    }
    ${({ align }) => (align === 'left' ? `left: 0;` : `right: 0;`)}
  }
`;

export const Select = styled('select')`
  position: absolute;
  bottom: 0;
  left: 0;
  opacity: 0;
  height: 40px;
  line-height: 40px;
  width: 100%;
  overflow-x: auto;
  -webkit-appearance: menulist-button;
  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
`;

export const OverlayTrigger = styled('input')`
  position: absolute;
  bottom: 0;
  left: 0;
  opacity: 0;
  height: 40px;
  line-height: 40px;
  width: 100%;
`;

export const ChevronDownIcon = styled(ChevronDownSmallSolid)`
  cursor: pointer;
`;
